import Tree from './Tree';


Tree.install = function(Vue) {
  Vue.component(Tree.name, Tree);
};

export default Tree;
